export default {"src":"/_next/static/media/signout.ab438be0.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};